var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.531 2.063c.25.25.469.718.469 1.062V11.5a1.5 1.5 0 01-1.5 1.5H10v1.5A1.5 1.5 0 018.5 16h-7A1.48 1.48 0 010 14.5v-10A1.5 1.5 0 011.5 3H4V1.5A1.5 1.5 0 015.5 0h5.375c.344 0 .813.219 1.063.469l1.593 1.594zM11 1.03V3h1.969c-.031-.063-.063-.156-.125-.219l-1.625-1.625c-.063-.062-.156-.093-.219-.125zM9 14.5V13H5.5A1.48 1.48 0 014 11.5V4H1.5c-.281 0-.5.25-.5.5v10c0 .281.219.5.5.5h7c.25 0 .5-.219.5-.5zm4-3V4h-2.25a.722.722 0 01-.75-.75V1H5.5c-.281 0-.5.25-.5.5v10c0 .281.219.5.5.5h7c.25 0 .5-.219.5-.5z",
    fill: "#868E96"
  })));
}
export default SvgCopy;